/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pr_Type_WeightInputs */

const fr_pr_type_weight = /** @type {(inputs: Pr_Type_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poids`)
};

/**

* @param {Pr_Type_WeightInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const pr_type_weight = /** @type {((inputs?: Pr_Type_WeightInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pr_Type_WeightInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_pr_type_weight(inputs)
});